var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIconOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8794_13525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8794_13525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03843 11.6665C5.70168 11.6665 5.41664 11.5498 5.18332 11.3165C4.94998 11.0831 4.83332 10.7981 4.83332 10.4613V2.87164C4.83332 2.53488 4.94998 2.24984 5.18332 2.0165C5.41664 1.78317 5.70168 1.6665 6.03843 1.6665H11.6281C11.9649 1.6665 12.2499 1.78317 12.4833 2.0165C12.7166 2.24984 12.8333 2.53488 12.8333 2.87164V10.4613C12.8333 10.7981 12.7166 11.0831 12.4833 11.3165C12.2499 11.5498 11.9649 11.6665 11.6281 11.6665H6.03843ZM6.03843 10.6665H11.6281C11.6794 10.6665 11.7264 10.6451 11.7692 10.6024C11.8119 10.5596 11.8333 10.5126 11.8333 10.4613V2.87164C11.8333 2.82035 11.8119 2.77333 11.7692 2.73059C11.7264 2.68785 11.6794 2.66649 11.6281 2.66649H6.03843C5.98714 2.66649 5.94013 2.68785 5.8974 2.73059C5.85466 2.77333 5.83328 2.82035 5.83328 2.87164V10.4613C5.83328 10.5126 5.85466 10.5596 5.8974 10.6024C5.94013 10.6451 5.98714 10.6665 6.03843 10.6665ZM3.70512 13.9998C3.36837 13.9998 3.08333 13.8831 2.85 13.6498C2.61667 13.4164 2.5 13.1314 2.5 12.7947V4.20497H3.49998V12.7947C3.49998 12.8459 3.52135 12.893 3.56408 12.9357C3.60683 12.9784 3.65384 12.9998 3.70512 12.9998H10.2948V13.9998H3.70512Z",
    fill: "#054BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconOutlined);
export default __webpack_public_path__ + "static/media/copy_icon-outlined.392ff3966f802b26187fecad48085a64.svg";
export { ForwardRef as ReactComponent };